import { Button, Group, Modal, Text } from "@mantine/core";
import React from "react";

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  Button1:string;
  Button2:string
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  onCancel,
  onConfirm,
  Button1,
  Button2
}) => {
  return (
    <Modal opened={isOpen} onClose={onClose} title={title}>
      <Text size="sm">{message}</Text>
      <Group position="right" mt="lg">
        <Button type="submit" size="sm" onClick={onCancel}>
          {Button1}
        </Button>
        <Button type="button" color="red" size="sm" onClick={onConfirm}>
          {Button2}
        </Button>
      </Group>
    </Modal>
  );
};

export default ConfirmModal;
